import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-list',
  templateUrl: './about-list.component.html',
  styleUrls: ['./about-list.component.scss']
})
export class AboutListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
